import { useTranslation } from 'react-i18next';

import { Box, CoinPointsOutline, forwardRef, rem, StyleProps, Text } from '@bonusly/design-system';

interface AmountChipProps extends StyleProps {
	amount: number;
	isDisabled?: boolean;
}

export const AmountChip = forwardRef<AmountChipProps, 'div'>(({ amount, isDisabled, ...rest }, ref) => {
	const { t } = useTranslation('common');

	return (
		<Box
			alignItems="center"
			bg={isDisabled ? 'blackAlpha.50' : 'green.25'}
			borderRadius={rem(60)}
			color={isDisabled ? 'gray.600' : 'green.700'}
			data-testid="amount-chip"
			display="flex"
			flexShrink={0}
			justifyContent="center"
			px={3}
			ref={ref}
			{...rest}
		>
			<CoinPointsOutline />
			<Text as="span" fontSize="md" fontWeight="medium" ml={2}>
				{t('intl_number', {
					value: amount,
					defaultValue: amount,
				})}
			</Text>
		</Box>
	);
});
